import React, { useState, useEffect } from 'react';
import { Breadcrumb, Button } from "antd";
import Icofont from "react-icofont";
import { errorCatch, GET, GetAnswer, JSXFirst, JSXMap } from '../../components/Tool';
import { useUserContext } from '../../components/Context';
import { useAuth } from '../../components/Auth';
import "./index.less"
import moment from 'moment';

function LineDescription(props) {
    const { title, value, unit, bold } = props;
    return (
        <div>
            <span style={(bold) ? { fontWeight: "600", fontSize: "18px" } : {}}>
                {title} {value} {unit}
            </span>
        </div>
    );
}
export default function Agrotechnology(props) {
    const auth = useAuth();
    const user = useUserContext();
    const [services, setServices] = useState();
    const [context, setContext] = useState();
    const [sortDefinition, setSortDefinition] = useState();

    useEffect(() => {
        // READWITH(auth, "Services",
        //     [
        //         QueryOrder("ID", "ASC")
        //     ],
        //     (res) => setServices(res.data),
        //     errorCatch
        // );
        GET(auth, "/api/context/last",
            (res) => {
                setContext(res.data);
                GET(auth, `/api/sort-definition/${res.data.ID}`,
                    (res) => setSortDefinition(res.data),
                    errorCatch
                );
            },
            errorCatch
        );
        // READWITH(auth, "Sorts",
        //     [
        //         QueryDetail("model"),
        //         QueryParam("w-ID", num)
        //     ],
        //     (res) => setSortDefinition(res.data),
        //     errorCatch
        // );

        // READ(auth, "Context",
        //     (res) => setContext(res.data),
        //     errorCatch
        // );
    }, []);

    return (<>
        <div style={{ padding: "0 24px" }}>
            <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item>Агротехнология</Breadcrumb.Item>
            </Breadcrumb>
        </div>
        <div className="site-layout-background" style={{ padding: 24, minHeight: 360, height: "100%" }}>
            <h2 style={{ textAlign: "center", padding: "15px 0px" }}>Перечень агротехнологических приемов</h2>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                    {(!!context) && <div>
                        <span>Формирование агротехнологии: </span>
                        <span>№{context.ID} от {moment(context.CreatedAt).format("DD.MM.YYYY HH:mm")}</span>
                    </div>}
                </div>
                <div>
                    <Button type="link"><Icofont icon="file-pdf" style={{ color: "red", paddingRight: "5px" }} /> Сохранить как pdf</Button>
                    <Button type="link"><Icofont icon="file-code" style={{ color: "skyblue", paddingRight: "5px" }} /> Сохранить как html</Button>
                </div>
            </div>
            <div>
                <div>
                    <span>Наименование культуры – «</span>
                    <span>
                        <a>
                            {JSXFirst(GetAnswer(context, 1), (q, idx) => {
                                return (q) ? q.answerDisplay : "";
                            })}
                        </a>
                    </span>
                    <span>»</span>
                </div>
                <div>
                    <span>Сорт – «</span>
                    <span>
                        <a>Деметра</a>
                        </span>
                    {/* {JSXMap(sortDefinition, (q, idx) => (
                        <div key={idx} style={{ paddingBottom: "5px" }}>
                            <a>
                                <LineDescription value={q.name} bold={true} />
                            </a>
                        </div>
                    ))} */}
                    <span>»</span>
                </div>
                <div>
                    <span>Регион возделывания – «</span>
                    <span>
                        {JSXFirst(GetAnswer(context, 2), (q, idx) => {
                            return (q) ? q.answerDisplay : "";
                        })}
                    </span>
                    <span>»</span>
                </div>
                <div>
                    <span>Предшественник – «</span>
                    <span>
                        <a>
                            {JSXFirst(GetAnswer(context, 4), (q, idx) => {
                                return (q) ? q.answerDisplay : "";
                            })}
                        </a>
                    </span>
                    <span>»</span>
                </div>
                <div className='agrotechnology' style={{ paddingTop: "15px" }}>
                    <table>
                        <thead>
                            <tr>
                                <th rowSpan="2">Наименование приема</th>
                                <th colSpan="2">Необходимая техника (если проводился подбор техники)</th>
                                <th rowSpan="2">Примечание</th>
                            </tr>
                            <tr>
                                <th>Трактор</th>
                                <th>С.х. машина</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan={4} style={{ fontWeight: "600" }}>Нормы и способы внесения удобрений и мелиорантов</td>
                            </tr>
                            <tr>
                                <td>Погрузка органических удобрений (<span style={{ textDecoration: "underline" }}><a>навоз подстилочный</a></span>)</td>
                                <td>Подбор не производился</td>
                                <td>Подбор не производился</td>
                                <td><span style={{ textDecoration: "underline" }}>20</span> т/га</td>
                            </tr>
                            <tr>
                                <td>Доставка и внесение органических удобрений (<span style={{ textDecoration: "underline" }}><a>навоз подстилочный</a></span>)</td>
                                <td>Подбор не производился</td>
                                <td>Подбор не производился</td>
                                <td><span style={{ textDecoration: "underline" }}>20</span> т/га</td>
                            </tr>
                            <tr>
                                <td>Погрузка минеральных удобрений</td>
                                <td>Подбор не производился</td>
                                <td>Подбор не производился</td>
                                <td>
                                    N<span style={{ textDecoration: "underline" }}>36</span>
                                    P<span style={{ textDecoration: "underline" }}>55</span>
                                    K<span style={{ textDecoration: "underline" }}>77</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Доставка и внесение минеральных удобрений </td>
                                <td>Подбор не производился</td>
                                <td>Подбор не производился</td>
                                <td>
                                    N<span style={{ textDecoration: "underline" }}>36</span>
                                    P<span style={{ textDecoration: "underline" }}>55</span>
                                    K<span style={{ textDecoration: "underline" }}>77</span>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>Внесение минеральных удобрений (при необходимости)</td>
                                <td>Указывается модель (при необходимости)</td>
                                <td>Указывается модель</td>
                                <td>Указывается рекомендуемая доза, т/га</td>
                            </tr> */}
                            {/* <tr>
                                <td>Подвоз воды (при необходимости)</td>
                                <td>Указывается модель (при необходимости)</td>
                                <td>Указывается модель</td>
                                <td>Указывается рекомендуемая доза, т/га</td>
                            </tr> */}
                            {/* <tr>
                                <td>Внесение жидких минеральных удобрений (при необходимости)</td>
                                <td>Указывается модель (при необходимости)</td>
                                <td>Указывается модель</td>
                                <td>Указывается рекомендуемая доза, т/га</td>
                            </tr> */}
                            {/* <tr>
                                <td>Погрузка мелиорантов (при необходимости)</td>
                                <td>Указывается модель (при необходимости)</td>
                                <td>Указывается модель</td>
                                <td>Указывается рекомендуемая доза, т/га</td>
                            </tr> */}
                            {/* <tr>
                                <td>Внесение мелиорантов (при необходимости)</td>
                                <td>Указывается модель (при необходимости)</td>
                                <td>Указывается модель</td>
                                <td>Указывается рекомендуемая доза, т/га</td>
                            </tr> */}
                            <tr>
                                <td colSpan={4} style={{ fontWeight: "600" }}>Способ основной обработки почвы</td>
                            </tr>
                            <tr>
                                <td>Поверхностная обработка (до 12 см)</td>
                                <td><a>МТЗ 1221</a></td>
                                <td><a>БДМ 3х2</a></td>
                                <td>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>Погрузка и доставка минеральных удобрений (при необходимости)</td>
                                <td>Указывается модель (при необходимости)</td>
                                <td>Указывается модель</td>
                                <td>Указывается рекомендуемая доза, т/га</td>
                            </tr> */}
                            {/* <tr>
                                <td>Внесение минеральных удобрений (при необходимости)</td>
                                <td>Указывается модель (при необходимости)</td>
                                <td>Указывается модель</td>
                                <td>Указывается рекомендуемая доза, т/га</td>
                            </tr> */}
                            {/* <tr>
                                <td>Предпосевная культивация</td>
                                <td>Указывается модель</td>
                                <td>Указывается модель</td>
                                <td></td>
                            </tr> */}
                            <tr>
                                <td colSpan={4} style={{ fontWeight: "600" }}>Предпосевная подготовка почвы</td>
                            </tr>
                            <tr>
                                <td>Предпосевная культивация</td>
                                <td><a>МТЗ-82.1</a></td>
                                <td><a>КПС-4</a></td>
                                <td>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={4} style={{ fontWeight: "600" }}>Предпосевная обработка семян</td>
                            </tr>
                            <tr>
                                <td>Предпосевная обработка семян</td>
                                <td>Не требуется</td>
                                <td><a>ПС-10</a></td>
                                <td>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>Погрузка и доставка минеральных удобрений (при необходимости) и семян</td>
                                <td>Указывается модель</td>
                                <td>Указывается модель</td>
                                <td>Указывается рекомендуемая доза (в случае прямого посева – это доза под основную обработку + под предпосевную культивацию + при посеве), в т/га</td>
                            </tr> */}
                            <tr>
                                <td colSpan={4} style={{ fontWeight: "600" }}>Способ посева</td>
                            </tr>
                            <tr>
                                <td>Посев <span style={{ textDecoration: "underline" }}>без</span> внесения удобрений</td>
                                <td><a>МТЗ-82.1</a></td>
                                <td><a>СЗ-5.4</a></td>
                                <td>
                                    Рекомендуемая норма высева
                                    - <span style={{ textDecoration: "underline" }}>0,20</span> т/га
                                    (<span style={{ textDecoration: "underline" }}>5,5</span> млн.шт./га)
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={4} style={{ fontWeight: "600" }}>Ранневесенние мероприятия</td>
                            </tr>
                            <tr>
                                <td>Погрузка и доставка минеральных удобрений </td>
                                <td>-</td>
                                <td><a>ГАЗ-САЗ 2507-01</a></td>
                                <td>
                                    <span style={{ textDecoration: "underline" }}>0,1</span> т/га
                                </td>
                            </tr>
                            <tr>
                                <td>Подкормка посевов </td>
                                <td><a>МТЗ-82.1</a></td>
                                <td><a>РУМ-800</a></td>
                                <td>
                                    <span style={{ textDecoration: "underline" }}>0,1</span> т/га
                                </td>
                            </tr>
                            {/* <tr>
                                <td>Ранневесеннее боронование озимых</td>
                                <td>Подбор не проводился</td>
                                <td>Подбор не проводился</td>
                                <td>
                                </td>
                            </tr> */}
                            <tr>
                                <td colSpan={4} style={{ fontWeight: "600" }}>Уход за посевами</td>
                            </tr>
                            <tr>
                                <td>Подвоз воды </td>
                                <td>-</td>
                                <td><a>ГАЗ-САЗ 2507-01</a> + Кассета 4000 литров</td>
                                <td>
                                </td>
                            </tr>
                            <tr>
                                <td>Обработка посевов пестицидами (в случае совместного применения подкормки и пестицидов – это Обработка посевов пестицидами и листовая подкормка)</td>
                                <td><a>МТЗ-82.1</a></td>
                                <td><a>ОПШ 2000-24</a></td>
                                <td>
                                    Препарат <span style={{ textDecoration: "underline" }}><a>Фенизан</a></span>. Норма
                                    внесение – <span style={{ textDecoration: "underline" }}>0,2</span> л/га. Расход рабочей
                                    жидкости – <span style={{ textDecoration: "underline" }}>300</span> л/га.
                                </td>
                            </tr>
                            {/* <tr>
                                <td>Погрузка и доставка минеральных удобрений (в случае варианта внесения вразброс или внутрипочвенно)</td>
                                <td>Указывается модель (при необходимости)</td>
                                <td>Указывается модель</td>
                                <td>Указывается количество подкормок и рекомендуемая доза, т/га</td>
                            </tr>
                            <tr>
                                <td>Подкормка посевов (в случае варианта внесения вразброс или внутрипочвенно)</td>
                                <td>Указывается модель (при необходимости)</td>
                                <td>Указывается модель</td>
                                <td>Указывается количество подкормок и рекомендуемая доза, т/га</td>
                            </tr>
                            <tr>
                                <td>Подвоз воды  (в случае варианта опрыскивания посевов)</td>
                                <td>Указывается модель (при необходимости)</td>
                                <td>Указывается модель</td>
                                <td>Указывается количество обработок и рекомендуемая доза расхода рабочей жидкости, т/га</td>
                            </tr>
                            <tr>
                                <td>Обработка посевов пестицидами (в случае совместного применения подкормки и пестицидов – это Обработка посевов пестицидами и листовая подкормка)</td>
                                <td>Указывается модель (при необходимости)</td>
                                <td>Указывается модель</td>
                                <td>Указывается количество обработок, наименование препарата и рекомендуемая доза (в случае совместного применения листовой подкормки и пестицидов – это доза подкормки + норма внесения пестицида), кг/га</td>
                            </tr>
                            <tr>
                                <td>Подвоз воды (в случае варианта отдельного внесения листовых подкормок)</td>
                                <td>Указывается модель (при необходимости)</td>
                                <td>Указывается модель</td>
                                <td>Указывается количество подкормок и рекомендуемая доза расхода рабочей жидкости, т/га</td>
                            </tr>
                            <tr>
                                <td>Внесение жидких минеральных удобрений (в случае варианта отдельного внесения листовых подкормок)</td>
                                <td>Указывается модель (при необходимости)</td>
                                <td>Указывается модель</td>
                                <td>Указывается количество подкормок и рекомендуемая доза, т/га</td>
                            </tr> */}
                            <tr>
                                <td colSpan={4} style={{ fontWeight: "600" }}>Уборка</td>
                            </tr>
                            <tr>
                                <td rowSpan={2}>Двухфазная уборка</td>
                                <td><a>208 Vario (Fendt)</a></td>
                                <td><a>ЖВЗ-6</a></td>
                                <td>
                                </td>
                            </tr>
                            <tr>
                                <td>-</td>
                                <td><a>КЗС-1218</a> + <a>ПЗ-4,4-3</a></td>
                                <td>
                                </td>
                            </tr>
                            {/* <tr>
                                <td rowSpan={2}>Двухфазная уборка</td>
                                <td>Указывается модель, если валковой жатке необходим для агрегатирования трактор</td>
                                <td>Указывается модель комбайна (если валковой жатке не требуется агрегатирование трактором) + модель жатки (во всех случаях)</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Не требуется</td>
                                <td>Указывается модель комбайна + модель жатки</td>
                                <td></td>
                            </tr> */}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </>);
}